import api from "../libs/api";

export default {
  directApproval: (queryString) => {
    return new Promise((resolve, reject) => {
      api()
        .get(`/direct-approval${queryString}`)
        .then(({ status, data }) => {
          if (status === 200 || status === 201) {
            resolve(data);
          } else {
            reject(new Error(`Failed with status: ${status}`));
          }
        })
        .catch((error) => reject(error));
    });
  },
};
